import React from 'react'
import { render } from 'react-dom'
import LandingPage from './landing-page'
import './index.scss'

render(<LandingPage />, document.getElementById('mog-script.github.io'))



// WEBPACK FOOTER //
// ./index.js